<template>
  <AppPanelShell
    storage-key="aradcore-dashboard"
    brand-subtitle="داشبورد مشتری"
    brand-icon="i-lucide-sparkles"
    :nav-items="navItems"
    :search-groups="searchGroups"
    :breadcrumbs="breadcrumbs"
    :tab-bar-items="tabBarItems"
    :flush="inVisitRoom"
  >
    <template #user-menu="{ collapsed, placement }">
      <div
        v-if="placement === 'navbar'"
        class="flex items-center gap-2"
      >
        <DashboardSiteSwitcher />
        <DashboardUserMenu />
      </div>
      <div
        v-else
        class="flex flex-col gap-2"
        :class="collapsed ? 'items-center' : 'w-full'"
      >
        <DashboardSmsQuota :collapsed="collapsed" />
        <DashboardStorageQuota :collapsed="collapsed" />
        <DashboardUserMenu :collapsed="collapsed" />
      </div>
    </template>
    <slot />
  </AppPanelShell>
  <DashboardModulePurchasePrompt />
</template>

<script setup lang="ts">
import DashboardUserMenu from '~/components/dashboard/UserMenu.vue'
import DashboardSmsQuota from '~/components/dashboard/SmsQuota.vue'
import DashboardStorageQuota from '~/components/dashboard/StorageQuota.vue'
import DashboardSiteSwitcher from '~/components/dashboard/SiteSwitcher.vue'
import DashboardModulePurchasePrompt from '~/components/dashboard/ModulePurchasePrompt.vue'
import { useDashboardNav } from '~/composables/useDashboardNav'
import { useAuthStore } from '~/stores/useAuthStore'
import { isDashboardPathAllowed } from '~/utils/practice/roles'

const route = useRoute()
const auth = useAuthStore()
const { navItems, searchGroups, breadcrumbs, locked } = useDashboardNav()

const { enabledKeys } = useSiteModules()

const inVisitRoom = computed(() => /\/booking\/virtual-visits\/[^/]+$/.test(route.path))

const tabBarItems = computed(() => {
  if (inVisitRoom.value) return []
  const role = auth.user?.siteRole ?? 'owner'
  const overview = locked.value ? '/dashboard/subscription' : '/dashboard'
  const isStaff = role === 'secretary' || role === 'doctor'
  const items = [
    { label: 'نمای کلی', icon: 'i-lucide-layout-dashboard', to: overview },
    { label: 'لیست بیماران', icon: 'i-lucide-clipboard-check', to: '/dashboard/reception' },
    { label: 'خدمات و نوبت دهی', icon: 'i-lucide-calendar-days', to: '/dashboard/booking' },
    { label: 'سوابق سلامت', icon: 'i-lucide-folder-heart', to: '/dashboard/health' },
  ]
  return items.filter((item) => {
    if (item.label === 'نمای کلی') return !isStaff
    if (!isDashboardPathAllowed(role, item.to, auth.user?.permissions)) return false
    if (isStaff) return true
    if (locked.value) return false
    if (item.to === '/dashboard/reception') {
      return enabledKeys.value.has('onlineBooking') || enabledKeys.value.has('healthRecord')
    }
    if (item.to === '/dashboard/booking') return enabledKeys.value.has('onlineBooking')
    if (item.to === '/dashboard/health') return enabledKeys.value.has('healthRecord')
    return true
  })
})
</script>
